// extracted by mini-css-extract-plugin
module.exports = {"Menu":"Menu_Menu__5zQix"};